import Vue from 'vue';
import App from "@/views/App.vue";
import vuetify from './plugins/vuetify';
import router from './router';
import store from "@/store";
import Keycloak from "keycloak-js";
import { VueMaskDirective,VueMaskFilter } from 'v-mask'
import VCalendar from 'v-calendar';
import PerfilService from "@/services/PerfilService";

Vue.filter('VMask', VueMaskFilter)
Vue.directive('mask', VueMaskDirective);
Vue.config.productionTip = false;

Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

const VUE_APP_KEYCLOAK_SERVICES = process.env.VUE_APP_KEYCLOAK_SERVICES;
const VUE_APP_REALM = process.env.VUE_APP_REALM;
const VUE_APP_CLIENT = process.env.VUE_APP_CLIENT;

const initOptions = {
  url: VUE_APP_KEYCLOAK_SERVICES,
  realm: VUE_APP_REALM,
  clientId: VUE_APP_CLIENT,
  onLoad: "login-required",
  checkLoginIframe: false,
  enableLogging: true,

};
const keycloak = Keycloak(initOptions);

function handleLocalStorage() {
  if (localStorage.session_id && localStorage.session_id !== keycloak.sessionId) {
    clearLocalStorage();
  }

  if (!localStorage.perfil_label) {
    localStorage.perfil_hir = 0;
    localStorage.perfil_label = 'Solicitante';
  }
}

function clearLocalStorage() {
  localStorage.removeItem('perfil_hir');
  localStorage.removeItem('perfil_id');
  localStorage.removeItem('perfil_label');
  localStorage.removeItem('user_id');
  localStorage.removeItem('perfil_label_admin');
  window.location.reload();
}

async function setUserRoles() {
  const roles = keycloak.resourceAccess.sigferias.roles;

  try {
    let response = await getPerfis();

    if (response) {
      const perfisDaAPI = response
        .map((perfil) => perfil.nome.toLowerCase());

      const ultimoPerfil   = response[response.length - 1];
      const matchingPerfil = perfisDaAPI.includes(ultimoPerfil.nome.toLowerCase()) &&
        Object.values(roles).some((perfilKeycloak) => {
          return ultimoPerfil.nome.toLowerCase() === perfilKeycloak.toLowerCase();
        });

      if (matchingPerfil) {
        localStorage.perfil_label_admin = 'admin';
        localStorage.perfil_id = ultimoPerfil.id;
        localStorage.perfil_label = ultimoPerfil.nome;
        localStorage.perfil_hir = ultimoPerfil.hierarquia;
        window.location.reload();
      }
    } else {
      console.warn('Resposta da API de perfis vazia.');
    }
  } catch (error) {
    console.error('Erro ao obter perfis:', error);
  }
}

async function getPerfis() {
  try {
    const response = await PerfilService.getPerfisSelect();

    if (!response.length) {
      return false;
    }

    return response;
  } catch (error) {
    console.error('Erro na chamada à API:', error);
    throw error;
  }
}

function initializeVueApp() {
  new Vue({
    store,
    vuetify,
    router,
    render: (h) => h(App, { props: { keycloak: keycloak } }),
  }).$mount("#app");
}

keycloak
  .init({ onLoad: initOptions.onLoad })
  .then((auth) => {
    if (!auth) {
      window.location.reload();
    } else {
      handleLocalStorage();

      if (!localStorage.session_id) {
        setUserRoles();
      }

      localStorage.session_id = keycloak.sessionId;

      initializeVueApp();

      setInterval(() => {
        keycloak
          .updateToken(70)
          .then((refreshed) => {
            if (refreshed) {
              Vue.prototype.$keycloak = keycloak;
            }
          })
          .catch((e) => console.error('Error refreshing token', e));
      }, 6000);
    }
  })
  .catch((e) => {
    console.error("Authentication Failed", e);
  });

Vue.prototype.$keycloak = keycloak;
